/**
 * Centralized location for generating application route URLs.
 * Use these functions instead of hardcoding paths throughout the app.
 */
export const AppUrls = {
  // OMS Orders
  createOmsOrder: () => '/oms/create-order',
  editOmsOrder: (orderId: string | number) => `/update-order/orderId/${orderId}`,

  // Sales Orders
  allOrders: () => '/orders-all',
  /** Temporary: legacy Sales Order Logs for OMS-connected accounts during stabilization. */
  oldOrdersAll: () => '/old-orders-all',
  salesOrderDetails: (orderId: string | number) => `/sales/details/${orderId}`,

  // Add more centralized routes here as needed
}
